const url =
  window.config && window.config.REACT_APP_WEBSOCKET
    ? window.config.REACT_APP_WEBSOCKET
    : 'ws://localhost:8080/socket';

export default url;

export function returnWebsocketUrl(pathRequest, websocketType) {
  // Get JWT token from localStorage to include in WebSocket connection
  const token = localStorage.getItem('jwt_token');
  const tokenParam = token ? `token=${encodeURIComponent(token)}&` : '';

  if (window?.config && window?.config?.REACT_APP_WEBSOCKET) {
    // Use the configured WebSocket URL (should already have correct protocol wss:// or ws://)
    return `${window.config.REACT_APP_WEBSOCKET}?${tokenParam}pathRequest=${pathRequest}&websocketType=${websocketType}`;
  } else {
    // Fallback for localhost - use ws:// for local development
    return `ws://localhost:8080/socket?${tokenParam}pathRequest=${pathRequest}&websocketType=${websocketType}`;
  }
}
